import { render } from "./ExplanationPane.vue?vue&type=template&id=7835b441&scoped=true"
import script from "./ExplanationPane.vue?vue&type=script&lang=js"
export * from "./ExplanationPane.vue?vue&type=script&lang=js"

import "./ExplanationPane.vue?vue&type=style&index=0&id=7835b441&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7835b441"

export default script